import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { BenefitsSection } from './components/BenefitsSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { RealitySection } from './components/RealitySection';
import { FAQSection } from './components/FAQSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-slate-950 text-slate-50 selection:bg-blue-500/30" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <MechanismSection data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <AudienceSection data-id="element-8" />
        <HowItWorksSection data-id="element-9" />
        <RealitySection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <PricingSection data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}